import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { UserRole } from '../../types/auth';
interface LayoutProps {
  children: React.ReactNode;
  activePage: string;
  setActivePage: (page: string) => void;
  onLogout: () => void;
  userRole: UserRole;
  userName: string;
  userUnit: string;
}
export const Layout: React.FC<LayoutProps> = ({
  children,
  activePage,
  setActivePage,
  onLogout,
  userRole,
  userName,
  userUnit
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
      if (window.innerWidth < 1024) {
        setSidebarCollapsed(true);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return <div className="flex h-screen bg-dark-900 text-gray-100 overflow-hidden font-sans selection:bg-primary selection:text-dark-900" data-id="element-670">
      <Sidebar activePage={activePage} setActivePage={setActivePage} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} userRole={userRole} data-id="element-671" />
      <div className="flex flex-col flex-1 overflow-hidden transition-all duration-300 ease-in-out" data-id="element-672">
        <Topbar toggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} collapsed={sidebarCollapsed} onLogout={onLogout} userName={userName} userRole={userRole} userUnit={userUnit} data-id="element-673" />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 bg-neutral-light text-gray-800 scrollbar-thin scroll-smooth" data-id="element-674">
          {children}
        </main>
      </div>
    </div>;
};